import { elevationCss } from '@creditornot/cb-ingredients';
import { Modal, ModalContent, ModalHeader } from '@creditornot/cbt-modal';
import { CookieConsents } from '@creditornot/cwc-cookie-sdk';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { ManageCookieConsentsForm } from './ManageCookieConsentsForm';

export type ManageCookieConsentsModalProps = {
  show: boolean;
  initialConsents: CookieConsents;
  onSubmit: (consents: CookieConsents) => void;
  onSubmitFailed: (error: any) => void;
  onClose: () => void;
};

const StyledModalHeader = styled(ModalHeader)`
  text-align: center;
`;

const Root = styled(Modal)`
  ${elevationCss(16)}
`;

const StyledContent = styled(ModalContent)`
  width: 100%;
  max-width: 600px;
`;

export const ManageCookieConsentsModal = ({
  show,
  onSubmit,
  onSubmitFailed,
  onClose,
  initialConsents,
}: ManageCookieConsentsModalProps) => {
  return (
    <Root open={show}>
      <StyledModalHeader>
        <FormattedMessage id="gdpr-consents.manage.title" />
      </StyledModalHeader>

      <StyledContent>
        <ManageCookieConsentsForm
          initialValues={initialConsents}
          onSubmit={onSubmit}
          onSubmitFailed={onSubmitFailed}
          onClose={onClose}
        />
      </StyledContent>
    </Root>
  );
};
